var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9752",
    "data-name": "Grupo 9752",
    transform: "translate(-351 -5154)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_87",
    "data-name": "Elipse 87",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(351 5154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "instagram-icon-1",
    d: "M1.815,0h11.37A1.825,1.825,0,0,1,15,1.824V13.176A1.825,1.825,0,0,1,13.185,15H1.815A1.825,1.825,0,0,1,0,13.176V1.824A1.825,1.825,0,0,1,1.815,0Zm-.2,6.176h1.5A4.489,4.489,0,0,0,2.877,7.63a4.624,4.624,0,0,0,9.246,0,4.5,4.5,0,0,0-.241-1.455h1.5v6.316a.813.813,0,0,1-.808.812H2.367a.751.751,0,0,1-.747-.751Zm9.291-4.689h1.741a.72.72,0,0,1,.715.719V3.832a.72.72,0,0,1-.715.719H10.911a.72.72,0,0,1-.715-.719V2.205A.72.72,0,0,1,10.911,1.486ZM7.5,4.426a2.955,2.955,0,1,1-3,2.954A2.979,2.979,0,0,1,7.5,4.426Z",
    transform: "translate(359 5162)",
    fill: "#3d3d3d",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7108abbb57f4d91d58f356c1fba24cb0.svg";
export { ForwardRef as ReactComponent };